import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=7dbccb9e&scoped=true"
import script from "./operate.vue?vue&type=script&lang=js"
export * from "./operate.vue?vue&type=script&lang=js"
import style0 from "./operate.vue?vue&type=style&index=0&id=7dbccb9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbccb9e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FGStyleSelector: require('C:/Users/xiao9/Desktop/projects/web-tattoo-workspace/components/FG/styleSelector.vue').default})
